import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import ActionConfirmationModal from '@organisms/actions/ActionConfirmationModal/ActionConfirmationModal';
import { RouteNames } from '@/router/router.types';
import { buildUrlWithReturnTo, getCurrentAsReturnTo, sanitizeReturnTo } from '@srm/core/routing';

export class RegisterOnBaseExecutor extends DocBaseActionExecutor {
    runInternal = (
        objId: string,
        _parentId: string | undefined,
        action: IBaseAction,
        _rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        if (!action.options?.confirmation) {
            this.doAction(action, completeHandler, objId);
        }
    };

    private doAction(action: IBaseAction, completeHandler: ((isSucceed: boolean) => void) | undefined, objId: string) {
        const targetPath = RouteNames.DOCUMENT_CREATE_ON_BASE.replace(':baseDocId', objId)
            .replace(':actId', action.key)
            .replace('/:draftId?', '');

        if (this.navigate) {
            if (action.options?.newTab) {
                window.open(targetPath, '_blank', 'noopener,noreferrer');
            } else {
                const existingReturnTo = sanitizeReturnTo(
                    new URLSearchParams(this.location?.search ?? '').get('returnTo'),
                );
                const returnTo =
                    existingReturnTo ??
                    getCurrentAsReturnTo(
                        this.location?.pathname ?? '',
                        this.location?.search ?? '',
                        this.location?.hash ?? '',
                    );
                this.navigate(buildUrlWithReturnTo(targetPath, returnTo));
            }
        } else {
            window.location.href = `.${targetPath}`;
        }
        completeHandler && completeHandler(false);
    }

    visualElementInner = () => {
        return this._action?.options?.confirmation ? (
            <ActionConfirmationModal
                title={this._action.options.confirmation.title}
                message={this._action.options.confirmation.message}
                okButtonText={this._action.options.confirmation.okButtonText}
                cancelButtonText={this._action.options.confirmation.cancelButtonText}
                onOkClick={() => {
                    if (this._action && this._objId) {
                        this.doAction(this._action, this._completeHandler, this._objId);
                    }

                    return new Promise<void>((resolve) => {
                        resolve();
                    });
                }}
                onCancelClick={() => {
                    this._completeHandler && this._completeHandler(false);
                }}
            />
        ) : (
            <></>
        );
    };
}
